import queryString from 'query-string';

import UriFiltering from 'utils/UriFiltering';
import UriSorting from 'utils/UriSorting';
import { filterDuck } from 'utils/duckify';

const queryBuilder = (currentEnrollmentYear, duck, location) => {
  const filters = new UriFiltering(location).getFilters();
  const sort = new UriSorting(location).getSortAsString();
  const filtersPresent = Object.getOwnPropertyNames(filters).length !== 0;
  const sortPresent = sort.length > 0;
  const query = queryString.parse(location.search);
  const page = query.page || 1;

  if (!(currentEnrollmentYear || query.school_year_id)) {
    return undefined;
  }

  const newQuery = {};

  if (currentEnrollmentYear.id) {
    newQuery.school_year_id = currentEnrollmentYear.id;
  }

  // If we have a school_year_id from the query params, it always wins
  if (query && query.school_year_id) {
    newQuery.school_year_id = query.school_year_id;
  }

  if (filtersPresent) {
    newQuery.filters = JSON.stringify(filters);
  }

  if (sortPresent) {
    newQuery.sort = sort;
  }

  if (query.page) {
    newQuery.page = page;
  }

  return filterDuck(duck, newQuery);
};

export default queryBuilder;
